<template>
  <main class="app-main" dir="rtl">
    <div class="app-content-header"><div class="container-fluid">
      <h3 class="mb-0">أنواع طلبات المواد التسويقية والتعميد</h3>
    </div></div>
    <div class="app-content"><div class="container-fluid">
      <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber" />
      <div class="card card-secondary card-outline">
        <div class="card-header d-flex flex-wrap gap-2 align-items-center">
          <strong class="me-auto">أنواع الطلبات</strong>
          <select v-model="category" class="form-select w-auto" aria-label="نوع القائمة" @change="changeCategory">
            <option value="">كل الأنواع</option>
            <option v-for="(label, key) in categories" :key="key" :value="key">{{ label }}</option>
          </select>
          <button v-if="checkAccess('marketing_material_options_create')" type="button" class="btn btn-primary" @click="openCreate">
            <i class="bi bi-plus-circle"></i> إضافة نوع
          </button>
        </div>
        <div class="card-body">
          <mainLoader v-if="loading" />
          <div v-else class="table-responsive">
            <table class="table table-striped align-middle">
              <thead><tr><th>#</th><th>الفئة</th><th>الاسم بالعربية</th><th>الاسم بالإنجليزية</th><th>الحالة</th><th>الإجراءات</th></tr></thead>
              <tbody>
                <tr v-for="row in rows" :key="row.id">
                  <td>{{ row.id }}</td>
                  <td>{{ categories[row.category] }}</td>
                  <td>{{ row.name }}</td>
                  <td>{{ row.nameEn }}</td>
                  <td><span :class="row.isActive ? 'text-success' : 'text-muted'">{{ row.isActive ? 'نشط' : 'غير نشط' }}</span></td>
                  <td>
                    <button v-if="checkAccess('marketing_material_options_update')" type="button" class="btn btn-light btn-sm ms-2" @click="openEdit(row)"><i class="bi bi-pencil"></i> تعديل</button>
                    <button v-if="checkAccess('marketing_material_options_delete')" type="button" class="btn btn-outline-danger btn-sm" @click="deleteRow(row)"><i class="bi bi-trash"></i> حذف</button>
                  </td>
                </tr>
                <tr v-if="!rows.length"><td colspan="6" class="text-center text-muted py-4">لا توجد أنواع في القائمة</td></tr>
              </tbody>
            </table>
          </div>
        </div>
        <div v-if="pages.length > 1" class="card-footer d-flex gap-2">
          <button v-for="page in pages" :key="page" type="button" class="btn btn-sm" :class="page === currentPage ? 'btn-primary' : 'btn-light'" @click="goToPage(page)">{{ page }}</button>
        </div>
      </div>
    </div></div>

    <div v-if="showForm" class="option-backdrop" @click.self="closeForm">
      <section class="option-dialog card" role="dialog" aria-modal="true" aria-labelledby="optionTitle">
        <div class="card-header d-flex align-items-center justify-content-between">
          <h5 id="optionTitle" class="mb-0">{{ editingId ? 'تعديل النوع' : 'إضافة نوع طلب' }}</h5>
          <button type="button" class="btn-close" aria-label="إغلاق" @click="closeForm"></button>
        </div>
        <form class="card-body" @submit.prevent="saveRow">
          <div class="mb-3">
            <label class="form-label">الفئة <span class="text-danger">*</span></label>
            <select v-model="form.category" class="form-select" :disabled="!!editingId" required>
              <option value="">اختر الفئة</option>
              <option v-for="(label, key) in categories" :key="key" :value="key">{{ label }}</option>
            </select>
          </div>
          <div class="mb-3"><label class="form-label">الاسم بالعربية <span class="text-danger">*</span></label><input v-model.trim="form.name" class="form-control" maxlength="255" required /></div>
          <div class="mb-3"><label class="form-label">الاسم بالإنجليزية <span class="text-danger">*</span></label><input v-model.trim="form.nameEn" class="form-control" maxlength="255" required /></div>
          <label class="form-check mb-3"><input v-model="form.isActive" type="checkbox" class="form-check-input" /><span class="form-check-label">نشط ومتاح في نماذج الطلبات</span></label>
          <div class="d-flex gap-2 justify-content-end">
            <button type="button" class="btn btn-light" @click="closeForm">إلغاء</button>
            <button type="submit" class="btn btn-primary" :disabled="saving">{{ saving ? 'جارٍ الحفظ...' : 'حفظ' }}</button>
          </div>
        </form>
      </section>
    </div>
  </main>
</template>

<script>
import {checkAccess, toast} from '@/helpers/tools';

const emptyForm = () => ({category: '', name: '', nameEn: '', isActive: true});

export default {
  name: 'MarketingMaterialOptions',
  data() {return {
    categories: {material: 'نوع خامة اللوحة', size: 'مقاس اللوحة', photography: 'نوع التصوير المطلوب', social: 'نوع التصميم / الحملة التسويقية'},
    category: '', rows: [], pages: [], currentPage: 1, loading: true, saving: false,
    showForm: false, editingId: null, form: emptyForm(), hasError: false, message: '', errorNumber: 0,
  };},
  methods: {
    checkAccess,
    async loadRows() {
      this.loading = true;
      this.hasError = false;
      try {
        const {data} = await this.$http.get('/api/admin/marketingMaterialOptions/list', {params: {category: this.category || undefined, page: this.currentPage}});
        this.rows = data.rows || [];
        this.pages = data.pages || [];
        this.categories = data.categories || this.categories;
      } catch(err) {this.setError(err);}
      finally {this.loading = false;}
    },
    setError(err) {
      [this.message, this.errorNumber] = this.$globalError(err, true);
      this.hasError = true;
    },
    changeCategory() {this.currentPage = 1; this.loadRows();},
    goToPage(page) {this.currentPage = page; this.loadRows();},
    openCreate() {this.editingId = null; this.form = {...emptyForm(), category: this.category}; this.showForm = true;},
    openEdit(row) {this.editingId = row.id; this.form = {category: row.category, name: row.name, nameEn: row.nameEn, isActive: row.isActive}; this.showForm = true;},
    closeForm() {if(!this.saving) this.showForm = false;},
    async saveRow() {
      if(!this.form.category || !this.form.name || !this.form.nameEn) return;
      this.saving = true;
      try {
        const url = this.editingId ? `/api/admin/marketingMaterialOptions/update/${this.editingId}` : '/api/admin/marketingMaterialOptions/create';
        await this.$http[this.editingId ? 'put' : 'post'](url, this.form);
        toast('تم حفظ النوع بنجاح', 'success');
        this.showForm = false;
        await this.loadRows();
      } catch(err) {this.setError(err);}
      finally {this.saving = false;}
    },
    async deleteRow(row) {
      const result = await this.$swal.fire({title: `حذف ${row.name}؟`, text: 'لن يظهر هذا النوع في الطلبات الجديدة.', icon: 'warning', showCancelButton: true, confirmButtonText: 'حذف', cancelButtonText: 'إلغاء'});
      if(!result.isConfirmed) return;
      try {
        await this.$http.delete(`/api/admin/marketingMaterialOptions/delete/${row.id}`);
        toast('تم حذف النوع', 'success');
        await this.loadRows();
      } catch(err) {this.setError(err);}
    },
  },
  created() {this.loadRows();},
};
</script>

<style scoped>
.option-backdrop {position:fixed; inset:0; z-index:1080; display:flex; align-items:center; justify-content:center; padding:1rem; background:rgba(15,23,42,.55)}
.option-dialog {width:min(100%, 560px); max-height:90vh; overflow:auto; margin:0}
</style>
